var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-view-default-template"},[_c('app-content-default-template',[_vm._t("default")],2),(_vm.showDisclaimer)?_c('news-profile-disclaimer'):_vm._e(),_c('subscription-widget',{ref:"subscription"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }